import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "../locales/en/translation.json";
import it from "../locales/it/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      it: { translation: it },
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

document.documentElement.lang = i18n.language.startsWith("it") ? "it" : "en";

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng.startsWith("it") ? "it" : "en";
});

export default i18n;
